export const activities = [
  // Xtreme Events (October 2025)
  {
    id: "16",
    title: "Data Structures",
    place: "INSAT",
    date: "8 October 2025",
    description:
      "This session covered the fundamental concepts of data structures, including arrays, linked lists, stacks, queues, trees and graphs. It emphasized their design, implementation and practical applications in efficient data storage and manipulation, forming a foundation for algorithm development and software engineering.\n",
    details: "Xtreme",
    images: [
      "xtreme2025/image1.png",
      "xtreme2025/image2.png",
      "xtreme2025/image3.png",
    ],
    facebookUrl: "https://www.facebook.com/IeeeInsatStudentBranch",
    instagramUrl: "https://www.instagram.com/ieee.insat.sb/",
  },
  {
    id: "15",
    title: "Introduction to Competitive Programming",
    place: "INSAT",
    date: "1 October 2025",
    description:
      "This session introduced the fundamentals of competitive programming, focusing on problem-solving techniques and algorithms. It emphasized efficient coding, logical reasoning and optimization strategies to solve algorithmic challenges under time constraints.\n",
    details: "Xtreme",
    images: [],
    facebookUrl: "https://www.facebook.com/IeeeInsatStudentBranch",
    instagramUrl: "https://www.instagram.com/ieee.insat.sb/",
  },
  // Summer School 8.0 Events (September 2025)
  {
    id: "14",
    title: "AI for Software Engineering",
    place: "INSAT",
    date: "28 September 2025",
    description:
      "This session explored the applications of Artificial Intelligence (AI) in software engineering, including code generation, bug detection and software testing automation. It highlighted how AI techniques can enhance productivity, improve code quality and support decision-making throughout the software development lifecycle.\n",
    details: "Summer School 8.0",
    images: [
      "summerSchool2025/ai-for-sw/image1.png",
      "summerSchool2025/ai-for-sw/image2.png",
    ],
    facebookUrl: "https://www.facebook.com/IeeeInsatStudentBranch",
    instagramUrl: "https://www.instagram.com/ieee.insat.sb/",
  },
  {
    id: "13",
    title: "Introduction to IT",
    place: "INSAT",
    date: "28 September 2025",
    description:
      "This session provided an overview of Information Technology (IT) fundamentals, including computer hardware and software, networks and basic IT services. It introduced core concepts such as data management, cybersecurity and system administration, offering a foundational understanding of IT principles and their applications in modern organizations.\n",
    details: "Summer School 8.0",
    images: [
      "summerSchool2025/intro-to-IT/image1.png",
      "summerSchool2025/intro-to-IT/image2.png",
    ],
    facebookUrl: "https://www.facebook.com/IeeeInsatStudentBranch",
    instagramUrl: "https://www.instagram.com/ieee.insat.sb/",
  },
  // AINS 3.0 Events (April 2025)
  {
    id: "12",
    title: "Introduction to Natural Language Processing",
    place: "INSAT",
    date: "12 April 2025",
    description:
      "This session introduced the fundamentals of Natural Language Processing (NLP), focusing on how computers analyze, understand, and generate human language. It covered key concepts such as text preprocessing, tokenization, and basic NLP tasks including text classification and sentiment analysis. The session provided a foundational understanding of NLP techniques and their applications.\n",
    details: "AINS 3.0",
    images: [],
    facebookUrl: "https://www.facebook.com/IeeeInsatStudentBranch",
    instagramUrl: "https://www.instagram.com/ieee.insat.sb/",
  },
  {
    id: "11",
    title: "Introduction to the Transformer Architecture",
    place: "INSAT",
    date: "8 April 2025",
    description:
      "In this session, we broke down the core concepts behind the Transformer architecture — the foundation of today's leading LLMs like Claude, GPT and BERT. We explored the basics of sequence models and how Transformers revolutionized them using attention and self-attention, enabling the capture of complex patterns in text without recurrence. Now the go-to architecture in NLP, Transformers have transformed how machines understand language.\n",
    details: "AINS 3.0",
    images: [],
    facebookUrl: "https://www.facebook.com/IeeeInsatStudentBranch",
    instagramUrl: "https://www.instagram.com/ieee.insat.sb/",
  },
  // Data Overflow 6.0 Events (January-February 2025)
  {
    id: "10",
    title: "DataQuest – Data Science Competition",
    place: "INSAT",
    date: "22–23 February 2025",
    description:
      "DataQuest was a 24-hour data science competition focused on solving real-world problems using data analysis and machine learning techniques. Participants worked under time constraints to explore datasets, build predictive models and present data-driven insights. The event encouraged teamwork, problem-solving and practical application of data science skills.\n",
    details: "Data Overflow 6.0",
    images: [
      "data-overflow-6/dataQuest/image2.png",
      "data-overflow-6/dataQuest/image3.png",
      "data-overflow-6/dataQuest/image5.png",
    ],
    facebookUrl: "https://www.facebook.com/IeeeInsatStudentBranch",
    instagramUrl: "https://www.instagram.com/ieee.insat.sb/",
  },
  {
    id: "9",
    title:
      "NVIDIA Workshop – Computer Vision for Industrial Inspection (Certified)",
    place: "INSAT",
    date: "16 February 2025",
    description:
      "This certified workshop focused on the application of computer vision techniques for industrial inspection. It covered the use of deep learning models to detect defects, perform visual quality control and automate inspection processes. The workshop emphasized practical use cases and NVIDIA tools, providing hands-on insights into deploying computer vision solutions in industrial environments.\n",
    details: "Data Overflow 6.0 - Certified",
    images: [
      "data-overflow-6/nvidia/image1.png",
      "data-overflow-6/nvidia/image2.png",
      "data-overflow-6/nvidia/image3.png",
    ],
    facebookUrl: "https://www.facebook.com/IeeeInsatStudentBranch",
    instagramUrl: "https://www.instagram.com/ieee.insat.sb/",
  },
  {
    id: "8",
    title: "Introduction to Computer Vision",
    place: "INSAT",
    date: "5 February 2025",
    description:
      "This session provided an overview of the fundamental concepts of Computer Vision, focusing on how machines interpret and analyze visual data. It introduced key topics such as image representation, feature extraction and basic vision tasks including image classification and object detection. The session laid the groundwork for understanding computer vision techniques and their applications.\n",
    details: "Data Overflow 6.0",
    images: [
      "data-overflow-6/computer-vision/image1.png",
      "data-overflow-6/computer-vision/image2.png",
      "data-overflow-6/computer-vision/image3.png",
    ],
    facebookUrl: "https://www.facebook.com/IeeeInsatStudentBranch",
    instagramUrl: "https://www.instagram.com/ieee.insat.sb/",
  },
  {
    id: "7",
    title: "Introduction to Machine Learning",
    place: "INSAT",
    date: "29 January 2025",
    description:
      "This session introduced the fundamental concepts of Machine Learning, highlighting its role within artificial intelligence and its main applications. It covered the basic learning paradigms (supervised, unsupervised and reinforcement learning), as well as key notions related to data, models and performance evaluation. The session provided a solid foundation for understanding how machine learning systems operate.\n",
    details: "Data Overflow 6.0",
    images: [
      "data-overflow-6/ml/image1.png",
      "data-overflow-6/ml/image2.png",
      "data-overflow-6/ml/image3.png",
    ],
    facebookUrl: "https://www.facebook.com/IeeeInsatStudentBranch",
    instagramUrl: "https://www.instagram.com/ieee.insat.sb/",
  },
  // 2021 Events (November-September 2021)
  {
    id: "1",
    title: "Advancing Through AI",
    place: "INSAT",
    date: "24 November 2021",
    description:
      'During the IEEE Region8 Cross-Sectional Student Initiatives Booster Program hosted by our IEEE INSAT student branch, our chapter held the "Advancing IoT through AI" workshop where Mouafek Ayedi explained some concepts about IoT, AI, and how the two can be connected.\n',
    details: "online industry AI formation",
    images: ["atai/photo.jpg"],
    facebookUrl: "https://www.facebook.com/IeeeInsatStudentBranch",
    instagramUrl: "https://www.instagram.com/ieee.insat.sb/",
  },
  {
    id: "3",
    title: "WebDev Workshop WEEK 2",
    place: "INSAT",
    date: "17 November 2021",
    description:
      "In the second session of our web development series our topic was css, our webmaster along with a whole team assured this workshop and helped all participants. The main points were: what is css, how does it work and the concept of classes and ids. The trainers explained also css selectors and properties. Finally, they tested the participants' comprehension of the concepts by a kahoot quizz where the fun, competition and learning were all mixed together.\n",
    details: "webdev workshop",
    images: [
      "webdev/week2/image6.jpg",
      "webdev/week2/image5.jpg",
      "webdev/week2/image1.jpg",
      "webdev/week2/image3.jpg",
      "webdev/week2/image2.jpg",
      "webdev/week2/image4.jpg",
    ],
    facebookUrl: "https://www.facebook.com/IeeeInsatStudentBranch",
    instagramUrl: "https://www.instagram.com/ieee.insat.sb/",
  },
  {
    id: "2",
    title: "WebDev Workshop WEEK 1",
    place: "INSAT",
    date: "13 November 2021",
    description:
      "We held our first series of workshops for web development where we introduced some basic concepts for front-end and back-end development and where we had Oussema Ghorbel tutoring our participants about some computer networks fundamentals. We ended our sessions with an introduction to Git and HTML and left the participants with homework for next session. We also made sure they met each other and bonded over the break between sessions.\n",
    details: "webdev workshop",
    images: [
      "webdev/week1/image5.jpg",
      "webdev/week1/image1.jpg",
      "webdev/week1/image2.jpg",
      "webdev/week1/image3.jpg",
      "webdev/week1/image4.jpg",
    ],
    facebookUrl: "https://www.facebook.com/IeeeInsatStudentBranch",
    instagramUrl: "https://www.instagram.com/ieee.insat.sb/",
  },
  {
    id: "4",
    title: "IEEE Extrem 15",
    place: "INSAT",
    date: "22/23 Octobre 2021",
    description:
      "IEEEXtreme 15.0 INSAT edition took place in INSAT with our theme being the Olympics. Our opening ceremony started with a word from the committee and was enclosed by a performance from a local band. Afterwards, the participants went to the competition space, had dinner and the 24h contest began. All along the journey they played games, ate a lot, watched a movie and slept too. In the feedback form, we found highly satisfied participants and that was our goal.\n",
    details: "online industry AI formation",
    images: [
      "xtreme/image5.jpg",
      "xtreme/image1.jpg",
      "xtreme/image3.jpg",
      "xtreme/image4.jpg",
    ],
    facebookUrl: "https://www.facebook.com/IeeeInsatStudentBranch",
    instagramUrl: "https://www.instagram.com/ieee.insat.sb/",
  },
  {
    id: "5",
    title: "Summer School CP",
    place: "INSAT",
    date: "11/12 Septembre 2021",
    description:
      "During this workshop, the trainer talked about the history of competitive programming, the interest in such competitions. Then he introduced the notion of applications' complexity and the rest of the workshop was dedicated to solving problems.\n",
    details: "Summer School",
    images: [
      "summerSchool/CP/image1.jpg",
      "summerSchool/CP/image2.jpg",
      "summerSchool/CP/image3.jpg",
      "summerSchool/CP/image4.jpg",
      "summerSchool/CP/image5.jpg",
    ],
    facebookUrl: "https://www.facebook.com/IeeeInsatStudentBranch",
    instagramUrl: "https://www.instagram.com/ieee.insat.sb/",
  },
  {
    id: "6",
    title: "Summer School Flutter",
    place: "INSAT",
    date: "10/11 Septembre 2021",
    description:
      "During this workshop, the trainers introduced some fundamental concepts needed for flutter then they taught the participants to develop some app pages, connect them, style the buttons and the text to end with making the logic which collects the answers either wrong or right ones.\n",
    details: "Summer School",
    images: [
      "summerSchool/flutter/image1.jpg",
      "summerSchool/flutter/image2.jpg",
      "summerSchool/flutter/image3.jpg",
      "summerSchool/flutter/image4.jpg",
      "summerSchool/flutter/image5.jpg",
    ],
    facebookUrl: "https://www.facebook.com/IeeeInsatStudentBranch",
    instagramUrl: "https://www.instagram.com/ieee.insat.sb/",
  },
];
